import React from 'react';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import './ContactButtons.css';

const ContactButtons = () => {
  const phoneNumber = "905453669008";
  const waMessage = "Merhaba, koleksiyonunuzdaki eserler hakkında bilgi alabilir miyim?";

  return (
    <>
      {/* Sol Alt: WhatsApp Butonu */}
      <a 
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(waMessage)}`} 
        className="fixed-wa-btn"
        target="_blank" 
        rel="noreferrer"
        aria-label="WhatsApp üzerinden iletişime geçin"
      >
        <FaWhatsapp />
        <span className="btn-tooltip">WhatsApp Hattı</span>
      </a>

      {/* Sağ Alt: Telefon Butonu */}
      <a 
        href={`tel:+${phoneNumber}`} 
        className="fixed-phone-btn"
        aria-label="Bizi arayın"
      >
        <FaPhoneAlt />
        <span className="btn-tooltip">Hemen Ara</span>
      </a>
    </>
  );
};

export default ContactButtons;